import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { RequestService } from 'src/app/services/request.service';

@Component({
  selector: 'app-spa-entrance',
  templateUrl: './spa-entrance.component.html',
  styleUrls: ['./spa-entrance.component.scss'],
})
export class SpaEntranceComponent implements OnInit {
  qrApiData = {
    email: this.authServ.profile.e_mail,
    tckno: this.authServ.profile.id_no,
    // "email": 'icibot@kolin.com',
    // "tckno": '1545875478',
  };

  loading = false;

  memberships: {
    addDate: string;
    amount: string;
    counter: string;
    ends: string;
    lessons: string;
    name: string;
    no: string;
    price: string;
    starts: string;
    remainingDays: string;
  }[] = [];

  showHintArrow = true;

  qrData: string;
  slideOpts = {
    initialSlide: 0,
    speed: 400,
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,
  };
  constructor(
    private requestServ: RequestService,
    private mdlctrl: ModalController,
    public authServ: AuthService
  ) {}

  async ngOnInit() {
    this.loading = true;
    if (!this.authServ.profile) {
      await this.authServ.getMe();
    } else {
      await this.requestServ
        .sendGym(this.qrApiData)
        .then(async (resp: any) => {
          if (resp.status === 'success') {
            this.qrData = resp.return.userQrData;
            let totalMemberships = resp.return.userMemberships;
            const today = new Date();
            this.memberships = totalMemberships?.filter((membership) => {
              const membershipEnds = new Date(membership.ends);
              membership.remainingDays = Math.floor(
                (membershipEnds.getTime() - today.getTime()) /
                  (1000 * 3600 * 24)
              ).toString();
              return membershipEnds > today;
            });
          }
        })
        .catch(async (err) => {
          console.log(err);
        });
    }
    this.loading = false;
  }

  async close() {
    await this.mdlctrl.dismiss();
  }

  slideChanged() {
    this.showHintArrow = false;
  }
}
